import React, { useState, useEffect, useCallback } from "react";
import io from "socket.io-client";
import { requestListTruckView } from "../../services/trukSocket.services";
import { Box, Typography, useTheme, Button, Paper, TextField, CircularProgress, InputBase } from "@mui/material";
import ProgressCircle from "../../components/ProgressCircle"; 
import { tokens } from "../../theme";
import { DataGrid } from "@mui/x-data-grid";
import { format, set, setYear } from "date-fns";
import { getProduccionView, updateLavadora } from "../../services/lavadoraSocket.services";
import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";
import ReporteLavadora from "../../registration/reporteLavadora";
import { es } from "date-fns/locale";
import ModalLavadoraStar from "../../modal/lavadora start/modalLavadora";
import { getOneOrdenProduccionxd, getOrdenOne } from "../../services/ordenProduccion.services";
// import {  } from "../../services/ordenProduccion.services";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getOne, putDescuentoStock} from "../../services/stock.services";
import VerticalShadesClosedIcon from '@mui/icons-material/VerticalShadesClosed';
import { getOneDatosCargadoraCab } from "../../services/cargadora.services";
import ModalCharge from "../../modal/modalCharge";
import ModalSuccess from "../../modal/modalSucces";
import ModalError from "../../modal/modalError";
import getUrlSocket from '../../utils/getUrlSocket';
import { getOrdenTejido } from "../../services/ordenTejido.services";
import { updateEstadoT } from "../../services/ordenTejido.services";
import SendIcon from '@mui/icons-material/Send';
import secureStorage from "../../utils/secureStorage";




const ProduccionRolos = () => {
    const theme = useTheme();
    const dividerColor = "#3d4254";
    const colors = tokens(theme.palette.mode);
    const [ordenes, setOrdenes] = useState([]);
    const [ordenSeleccionada, setOrdenSeleccionada] = useState(null);
    const [ordenProduciendo, setOrdenProduciendo] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [maquina, setMaquina] = useState("");
    const [peso, setPeso] = useState("");
    const [fullscreen, setFullscreen] = useState(false);
    const [ordenActual, setOrdenActual] = useState({
      producto: "",
      medidas: "",
      cantidad: 0,
    });



const fetchOrdenesProduccion = async () => {
  try {
    const response = await getOrdenTejido();

    // Validamos que sea un array o adaptamos el contenido
    const data = Array.isArray(response) ? response : response?.data;

    if (!Array.isArray(data)) {
      console.error("⚠️ Los datos no tienen el formato esperado:", data);
      return;
    }

    // Mapeamos asegurando que cada fila tenga un ID
    const ordenesFormateadas = data.map((orden, index) => ({
      id: orden.id,
      codigo: orden.codigo,
      producto: orden.producto,
      cliente: orden.cliente,
      estado: orden.estado,
      cantidad: orden.cantidad,
      alto: orden.alto,
      largo: orden.largo,
      cargados: orden.cargados,
    }));

    setOrdenes(ordenesFormateadas);
    const ordenActiva = ordenesFormateadas.find(o => o.estado === 1);
    if (ordenActiva) {
    setOrdenProduciendo(ordenActiva);
    secureStorage.setItem("ordenProduciendo", JSON.stringify(ordenActiva));
}

  } catch (error) {
    console.error("❌ Error al obtener las órdenes de producción:", error);
  }
};

  useEffect(() => {
    fetchOrdenesProduccion();
    const ordenGuardada = secureStorage.getItem("ordenProduciendo");
    if (ordenGuardada) {
      setOrdenProduciendo(JSON.parse(ordenGuardada));
    }
  }, []);

  

  const columnas = [
    { field: "id", headerName: "ID", flex: 0.2 },
    { field: "producto", headerName: "Producto", flex: 1.5 },
    { field: "cliente", headerName: "Cliente", flex: 1 },
    { field: "medidas", headerName: "Medidas", flex: 1.2,
        renderCell: (params) => {
        const alto = params.row.alto;
        const largo = params.row.largo;
        return `${alto} m x ${largo} m`;
      }
    },
    { field: "cantidad", headerName: "Cantidad", flex: 1 },
    { field: "estado", headerName: "Estado", flex: 1, renderCell: (params) => {
      switch (params.value) {
        case 0:
          return "Programado";
        case 1:
          return "En proceso";
        case 2:
          return "Concluido";
        default:
          return "Desconocido";
      }
    }, },
    
  ];

  return (
    <Box 
        display="flex" sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "background.default",
        zIndex: 9999,
        display: "flex", // importante para mantener las dos columnas lado a lado
        justifyContent: "center", // centrado horizontal
        alignItems: "center",}}>
          <Box
      sx={{
        display: "flex",
        width: "98vw",
        height: "95vh",
        backgroundColor: "#1e2538", // fondo de la caja
        borderRadius: "10px",
        boxShadow: "0 0 15px rgba(0,0,0,0.5)", // sombra
        overflow: "hidden", // para que las columnas no sobresalgan
      }}
    >
      {/* Primera columna: Órdenes */}
      <Box
        flex={1}
        p={2}
        sx={{
          borderRight: `2px solid ${dividerColor}`,
          backgroundColor: "theme.palette.background.default",
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[900],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[900],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        "& .estado-programado": {
            backgroundColor: "#740017", 
          },
          "& .estado-proceso": {
            backgroundColor: "#ff6105",
          },
          "& .estado-concluido": {
            backgroundColor: "green", 
          },
          borderRight: "2px solid #444",
        }}
      >
        <Typography variant="h2" gutterBottom
            sx={{ 
                fontWeight: "bold",
                marginBottom: 3,
                color: "rgb(206, 220, 0)", 
                fontSize: "4vh"
            }}
>
          Órdenes de Producción
        </Typography>
         <Typography variant="subtitle1" sx={{ mt: 2 ,
            fontWeight: "bold",
            marginBottom: 3,
            fontSize: "3vh"
         }}>
            {ordenProduciendo
            ? `Orden ${ordenProduciendo.id} iniciada`
            : ordenSeleccionada
            ? `Iniciar orden: ${ordenSeleccionada.id}`
            : "Seleccionar una orden"}
        </Typography>

        <Box height="50vh">
          <DataGrid
            rows={
              ordenProduciendo
                ? ordenes.filter((orden) => orden.estado !== 0)
                : ordenes
            }
            columns={columnas}
            onRowClick={(params) => setOrdenSeleccionada(params.row)}
            getRowId={(row) => row.id}
            pageSize={5}
            rowsPerPageOptions={[5]}
            disableSelectionOnClick
            getRowClassName={(params) => {
                switch (params.row.estado) {
                  case 0:
                    return "estado-programado";
                  case 1:
                    return "estado-proceso";
                  case 2:
                    return "estado-concluido";
                  default:
                    return "";
                }
            }}
          />

<Box mt={2} display="flex" gap={2}>
  <Button
    onClick={async () => {
      if (!ordenProduciendo && ordenSeleccionada) {
        try {
          // Cambiar estado a 1 (en proceso)
          await updateEstadoT(ordenSeleccionada.id, { estado: 1 });
          

          setOrdenProduciendo(ordenSeleccionada);
          setOrdenProduciendo(ordenSeleccionada);
          secureStorage.setItem("ordenProduciendo", JSON.stringify(ordenSeleccionada));
          toast.success(`Orden ${ordenSeleccionada.id} iniciada`, {
            position: "top-center",
          });
        
          // Volver a cargar la lista para reflejar cambios
          fetchOrdenesProduccion();
        } catch (error) {
          console.error("Error al iniciar la producción:", error);
          toast.error("Error al iniciar producción", { position: "top-center" });
        }
      }
    }}
    disabled={!!ordenProduciendo || !ordenSeleccionada}
    sx={{
      backgroundColor: ordenProduciendo ? "rgba(37, 255, 52, 0.5)" : "rgb(37, 255, 52)",
      border: "none",
      color: "black",
      height: "7vh",
      width: "15vw",
      borderRadius: "20px",
      cursor: ordenProduciendo || !ordenSeleccionada ? "not-allowed" : "pointer",
      "&:hover": {
        backgroundColor: ordenProduciendo ? "rgba(186, 198, 9, 0.5)" : "#bac609",
      },
    }}
    variant="contained"
  >
    Iniciar Producción
  </Button>

  <Button
    onClick={async () => {
      try {
        await updateEstadoT(ordenProduciendo.id, { estado: 0 });
      
        toast.error(`Orden ${ordenProduciendo.id} cancelada`, {
          position: "top-center",
        });
      
        setOrdenProduciendo(null);
        setOrdenSeleccionada(null);
        secureStorage.removeItem("ordenProduciendo");
      
        // Volver a cargar la lista para reflejar cambios
        fetchOrdenesProduccion();
      } catch (error) {
        console.error("Error al cancelar producción:", error);
        toast.error("Error al cancelar producción", { position: "top-center" });
      }
    }}
    disabled={!ordenProduciendo}
    sx={{
      backgroundColor: ordenProduciendo ? "rgba(209, 0, 0, 0.8)" : "rgba(209, 0, 0, 0.5)",
      border: "none",
      color: "black",
      height: "7vh",
      width: "15vw",
      borderRadius: "20px",
      cursor: ordenProduciendo ? "pointer" : "not-allowed",
      "&:hover": {
        backgroundColor: ordenProduciendo ? "#c00000" : "rgba(209, 0, 0, 0.5)",
      },
    }}
    variant="contained"
  >
    Cancelar Producción
  </Button>
</Box>


        </Box>
      </Box>

      {/* Segunda columna: Detalle */}
<Box flex={1} p={2} sx={{ backgroundColor: "theme.palette.background.defaul" }}>
    <Typography variant="h2" gutterBottom sx={{ 
                fontWeight: "bold",
                marginBottom: 3,
                color: "rgb(206, 220, 0)", 
                fontSize: "4vh"
            }}>Orden de Producción N°:</Typography>

  {ordenProduciendo ? (
    <>
      <Typography variant="h6" sx={{ mt: 2 ,
            fontWeight: "bold",
            marginBottom: 3,
            fontSize: "3vh"}}>Producto: {ordenProduciendo.producto}</Typography>
      <Typography variant="h6" sx={{ mt: 2 ,
            fontWeight: "bold",
            marginBottom: 3,
            fontSize: "3vh"}}>Cliente: {ordenProduciendo.cliente}</Typography>
      <Typography variant="h6" sx={{ mt: 2 ,
            fontWeight: "bold",
            marginBottom: 3,
            fontSize: "3vh"}}>
        Medidas: {ordenProduciendo.alto} m x {ordenProduciendo.largo} m
      </Typography>
      <Typography variant="h6" sx={{ mt: 2 ,
            fontWeight: "bold",
            marginBottom: 3,
            fontSize: "3vh"}}>Cantidad Total: {ordenProduciendo.cargados}/{ordenProduciendo.cantidad}</Typography>

      <Box mt={2} display="flex" flexDirection="row" gap={2} sx={{
              height: "35vh",
              width: "45vw",
              background: "#2a324d",
              margin: "auto",
              marginTop: "5vh"}} >
        <Box mt={2} display="flex" flexDirection="column" gap={2} sx={{flex: 1, p: 2 , justifyContent: "center"}}>
        <Typography variant="h6" sx={{ mt: 2 ,
            fontWeight: "bold",
            marginBottom: 3,
            fontSize: "3vh"}}>Máquina: <InputBase
            sx={{
              flex: 1,
              backgroundColor: "#1b2136",
              padding: "20px 10px",
              borderRadius: "4px",
              height: "30px",
              marginLeft: "10px",
              color: "white",
              fontSize: "20px",
            }}
            value={maquina}
            onChange={(e) => setMaquina(e.target.value)}
        /> </Typography>
        <Typography variant="h6" sx={{ mt: 2 ,
            fontWeight: "bold",
            marginBottom: 3,
            fontSize: "3vh"}}>Peso: <InputBase
            sx={{
              flex: 1,
              backgroundColor: "#1b2136",
              padding: "20px 10px",
              borderRadius: "4px",
              height: "30px",
              marginLeft: "10px",
              color: "white",
              fontSize: "20px",
            }}
            value={peso}
            onChange={(e) => setPeso(e.target.value)}
        /> </Typography>

        </Box>
        <Box mt={4} display="flex" justifyContent="center" alignItems="center" flexDirection="column" sx={{flex: 1, p: 2, boxSizing: "border-box", maxHeight: "100%", overflow: "hidden" }}>
            <Box position="relative" display="inline-flex" mt={1} sx={{ maxWidth: "100%", maxHeight:"100%", overflow: "hidden", boxSizing: "border-box"}}> 
          <ProgressCircle
          variant="determinate"
          value={
          ordenProduciendo
            ? (ordenProduciendo.cargados / ordenProduciendo.cantidad) * 100
            : 0
            }
            progress={ordenProduciendo
              ? Math.min(1, Math.max(0, ordenProduciendo.cargados / ordenProduciendo.cantidad))
              : 0}
            size="250"
            thickness={5}
              />
          <Box
            top={0}
            left={0}
            bottom={0}
            right={0}
            position="absolute"
            display="flex"
            alignItems="center"
            justifyContent="center"
              >
            <Typography variant="caption" component="div" color="text.secondary "sx={{ fontSize: '2rem', fontWeight: 'bold' }}>
              {ordenProduciendo
                ? `${Math.round((ordenProduciendo.cargados / ordenProduciendo.cantidad) * 100)}%`
                : "0%"}
            </Typography>
          </Box>
        </Box>
        
  </Box>
        
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center", mt: 3, marginTop: "4vh"}}>
        <Button
          type="submit"
          variant="contained"
          sx={{
          width: 100,
          height: 100,
          borderRadius: "50%",
          border: "5px solid #fff",
          minWidth: 0, 
          fontSize: 32,
          padding: 0,
        }}><SendIcon sx={{ color: "white", fontSize: 38}} />
        </Button>
      </Box>
    </>
  ) : (
    <>
      <Typography variant="h6" sx={{ mt: 2 ,
            fontWeight: "bold",
            marginBottom: 3,
            fontSize: "3vh"}}>Producto:</Typography>
      <Typography variant="h6" sx={{ mt: 2 ,
            fontWeight: "bold",
            marginBottom: 3,
            fontSize: "3vh"}}>Cliente:</Typography>
      <Typography variant="h6" sx={{ mt: 2 ,
            fontWeight: "bold",
            marginBottom: 3,
            fontSize: "3vh"}}>Medidas:</Typography>
      <Typography variant="h6" sx={{ mt: 2 ,
            fontWeight: "bold",
            marginBottom: 3,
            fontSize: "3vh"}}>Cantidad Total: 0/0</Typography>
      <Box mt={2} display="flex" flexDirection="row" gap={2} sx={{
              height: "35vh",
              width: "45vw",
              background: "#2a324d",
              margin: "auto",
              marginTop: "5vh"}} 
      >

      </Box>
    </>
  )}
  </Box>
</Box>
</Box>
  );
};

export default ProduccionRolos;


